import { Breadcrumbs, CourseCard, OnboardingCard } from '@components';
import {
  convertMaterialsToString,
  convertMinutesToTimeString,
  convertTestToString,
} from '@helpers';
import {
  useNavigateWithOfflineMode,
  useScreenSize,
  useScrollToTop,
} from '@hooks';
import OnboardingCover from '@pngs/AboutUsPage/ambassador4.png';
import Camo from '@pngs/Camo.png';
import Net from '@pngs/CoursesPage/Net.png';
import { courseApi } from '@store';
import { Flex, theme, Typography } from '@styles';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { coursesPageLayoutByVariant } from './CoursesPage.layoutProps';

const CoursesPage = () => {
  const { navigate } = useNavigateWithOfflineMode();
  const { device } = useScreenSize();
  const { i18n } = useTranslation();
  const { isTabletLG } = useScreenSize();
  const layout = coursesPageLayoutByVariant[device || 'desktop'];

  const { data, refetch } = courseApi.useGetCoursesQuery();

  useScrollToTop();

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  // TO DO convert links in courses to navigation
  const handleNavigateToCourse =
    ({ pageTitle, path }) =>
    () => {
      navigate(path, { state: { pageTitle } });
    };

  return (
    <Flex
      backgroundImage={Net}
      backgroundPosition="right 0 top 32px"
      backgroundRepeat="no-repeat"
      backgroundSize="60%"
      flexDirection="column"
    >
      <Breadcrumbs containerProps={{ px: layout?.px }} />
      <Flex
        backgroundImage={Camo}
        backgroundRepeat="repeat-x"
        flex={1}
        flexDirection="column"
        gap={24}
        pb={80}
        pt={24}
        px={layout?.px}
      >
        <Flex flexDirection={isTabletLG ? 'column' : 'row'} gap={24}>
          <Typography
            color={theme.colors.white[100]}
            variant="BN-bold-s123-lh104"
          >
            {i18n.t('CoursesPage.Title')}
          </Typography>
          <Typography
            color={theme.colors.white[60]}
            variant="MS-regular-s16-lh25"
            width="90%"
          >
            {i18n.t('CoursesPage.Description')}
          </Typography>
        </Flex>
        <Flex
          flexDirection={isTabletLG ? 'column' : 'row'}
          gap={isTabletLG ? 16 : 4}
        >
          <OnboardingCard
            cover={OnboardingCover}
            handleNavigate={handleNavigateToCourse({ path: 'onboarding' })}
            time={convertMinutesToTimeString(5)}
            title={i18n.t('CoursesPage.Onboarding').toUpperCase()}
          />
          {data?.data?.courses?.map((item) => (
            <CourseCard
              key={item?.id}
              cover={item?.image}
              description={item?.description}
              handleNavigate={handleNavigateToCourse({
                pageTitle: item?.title,
                path: `/courses/${item?.id}`,
              })}
              isAvailable
              isCoursesPage
              isLastAvailable
              isLoggedIn
              materials={convertMaterialsToString({
                isCourse: true,
                value: item?.materials_count,
              })}
              test={i18n.t(convertTestToString(true))}
              time={convertMinutesToTimeString(item?.minutes_count)}
              title={item?.title}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CoursesPage;
